import de_de from "../../assets/i18n/resources/resources-locale_de-de.json" assert { type: "json" };
import en_gb from "../../assets/i18n/resources/resources-locale_en-gb.json" assert { type: "json" };
import en_us from "../../assets/i18n/resources/resources-locale_en-us.json" assert { type: "json" };
import es_us from "../../assets/i18n/resources/resources-locale_es-us.json" assert { type: "json" };
import fr_fr from "../../assets/i18n/resources/resources-locale_fr-fr.json" assert { type: "json" };
import it_it from "../../assets/i18n/resources/resources-locale_it-it.json" assert { type: "json" };
import ja_jp from "../../assets/i18n/resources/resources-locale_ja-jp.json" assert { type: "json" };
import ko_kr from "../../assets/i18n/resources/resources-locale_ko-kr.json" assert { type: "json" };
import pt_pt from "../../assets/i18n/resources/resources-locale_pt-pt.json" assert { type: "json" };
import ru_ru from "../../assets/i18n/resources/resources-locale_ru-ru.json" assert { type: "json" };
import sv_se from "../../assets/i18n/resources/resources-locale_sv-se.json" assert { type: "json" };
import th_th from "../../assets/i18n/resources/resources-locale_th-th.json" assert { type: "json" };
import zh_cn from "../../assets/i18n/resources/resources-locale_zh-cn.json" assert { type: "json" };
import zh_tw from "../../assets/i18n/resources/resources-locale_zh-tw.json" assert { type: "json" };
export const TRANSLATION_NAMES = [
    "de",
    "en-GB",
    "en-US",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "pt",
    "ru",
    "sv",
    "th",
    "zh-CN",
    "zh-TW",
];
export const TRANSLATIONS = {
    de: de_de,
    "en-GB": en_gb,
    "en-US": en_us,
    es: es_us,
    fr: fr_fr,
    it: it_it,
    ja: ja_jp,
    ko: ko_kr,
    pt: pt_pt,
    ru: ru_ru,
    sv: sv_se,
    th: th_th,
    "zh-CN": zh_cn,
    "zh-TW": zh_tw,
};
export { default as i18NextFormatters } from "./formatter/index.js";
